<div class="ds-form-control__wrapper">
    <ng-container *ngIf="label">
        <label class="ds-form-control__label" [for]="id">{{ label }}</label>
    </ng-container>

    <mat-form-field appearance="outline" class="ds-form-control__item ds-datepicker" subscriptSizing="dynamic">
        <input
            [id]="id"
            [disabled]="disabled"
            [placeholder]="placeholder"
            [formControl]="control"
            [matDatepicker]="picker"
            (click)="picker.open()"
            [max]="max"
            [min]="min"
            matInput
        />

        <mat-icon
            *ngIf="isClearable && hasSelection && !disabled"
            class="ds-datepicker__clear"
            fontSet="material-symbols-rounded"
            matIconSuffix
            (click)="onClearSelection($event)"
            >close</mat-icon
        >

        <mat-datepicker-toggle *ngIf="!(isClearable && hasSelection && !disabled)" matIconSuffix [for]="picker"></mat-datepicker-toggle>

        <mat-datepicker #picker></mat-datepicker>

        <mat-error>
            <ng-content select="mat-error"></ng-content>
        </mat-error>

        <mat-hint>
            <ng-content select="mat-hint"></ng-content>
        </mat-hint>
    </mat-form-field>
</div>
